import axios from "axios";
import {notify} from "notiwind";
import router from "@/router";

export async function useFetch(url, token) {

    const response = axios({
        url: "https://billing.clafoutis.eu/api/" + url,
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then((r) => {
        return r
    }).catch((error) => {
        if (error.response.status === 404) {
            router.push("/404")
        }

        if (error.response.status !== 200) {
            notify({
                group: "bottom",
                title: "Une erreur est survenue !",
                text: "Le chargement n'a pas été effectué correctement. " + error.response.status + error.response.data,
                type: "error"
            }, 10000)
        }
        console.warn('ERROR: ' + error);

    })
    return response;
}

export async function usePost(url, data, token) {
    const response = axios({
        url: "https://billing.clafoutis.eu/api/" + url,
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    }).then((r) => {
        notify({
            group: "bottom",
            title: "Sauvegardé avec succès !",
            text: `Le changement a bien été effectué.`,
            type: "success"
        }, 10000)
        // if(r.data.result_array !== undefined) {
        //     notify({
        //         group: "bottom",
        //         title: "Sauvegardé avec succès !",
        //         text: `Le changement a bien été effectué.`,
        //         type: "success"
        //     }, 10000)
        // }
        return r
    }).catch((error) => {

        notify({
            group: "bottom",
            title: "Une erreur est survenue !",
            text: "Le changement n'a pas été effectué" + error.response.status + error.response.data,
            type: "error"
        }, 10000)


        console.warn('ERROR: ' + error);

    })
    return response;
}

export async function fetchProfile(token) {
    const endpoint = '/user'
    let status = false
    const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    HTTP.get("/user")
        .then(response => {
            console.log(response.data)
            this.profileData = response.data
            status = true
        })
        .catch(e => {
            status = false
            console.log(e)
        })
    return status
}

export async function usePostFile(url, data, token) {
    const response = axios({
        url: "https://billing.clafoutis.eu/api/" + url,
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        },
        data: data,
    }).then((r) => {
        notify({
            group: "bottom",
            title: "Le fichier a bien été importé !",
            text: "Il est maintenant présent en base.",
            type: "success"
        }, 10000)
        return r
    }).catch((error) => {

        notify({
            group: "bottom",
            title: "Une erreur est survenue !",
            text: "Le fichier n'a pas été importé " + error,
            type: "error"
        }, 10000)

        console.warn('ERROR: ' + error);
        throw error;

    })
    return response;
}

export async function useTransferFetch(url, token, params = {}) {
    try {
        const response = await axios({
            url: "https://billing.clafoutis.eu/api/" + url,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: params
        });
        return response;
    } catch (error) {
        if (error.response.status === 404) {
            router.push("/404");
        }
        
        if (error.response.status !== 200) {
            notify({
                group: "bottom",
                title: "Une erreur est survenue !",
                text: "Le chargement des virements n'a pas été effectué correctement. " + error.response.status,
                type: "error"
            }, 10000);
        }
        console.warn('ERROR: ' + error);
        throw error;
    }
}

export async function useTransferPost(url, data, token) {
    try {
        const response = await axios({
            url: "https://billing.clafoutis.eu/api/" + url,
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: data,
        });
        
        notify({
            group: "bottom",
            title: "Virement créé avec succès !",
            text: `Le virement a été créé et est en cours de traitement.`,
            type: "success"
        }, 10000);
        
        return response;
    } catch (error) {
        if (error.response && error.response.status === 422) {
            notify({
                group: "bottom",
                title: "Erreur de validation",
                text: error.response.data.message || "Veuillez vérifier les données saisies.",
                type: "error"
            }, 10000);
        } else {
            notify({
                group: "bottom",
                title: "Une erreur est survenue !",
                text: "Le virement n'a pas pu être créé. " + (error.response?.data?.message || error.message),
                type: "error"
            }, 10000);
        }
        
        console.warn('ERROR: ' + error);
        throw error;
    }
}

export async function useTransferConfig(token) {
    try {
        const response = await axios({
            url: "https://billing.clafoutis.eu/api/qonto/transfers/config",
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        notify({
            group: "bottom",
            title: "Erreur de configuration",
            text: "Impossible de charger la configuration des virements.",
            type: "error"
        }, 10000);
        
        console.warn('ERROR: ' + error);
        throw error;
    }
}

export async function useTransferCancel(transferId, token) {
    try {
        const response = await axios({
            url: `https://billing.clafoutis.eu/api/qonto/transfers/${transferId}/cancel`,
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        notify({
            group: "bottom",
            title: "Virement annulé avec succès !",
            text: `Le virement a été annulé.`,
            type: "success"
        }, 10000);
        
        return response;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 404) {
                notify({
                    group: "bottom",
                    title: "Virement non trouvé",
                    text: "Le virement que vous tentez d'annuler n'existe pas.",
                    type: "error"
                }, 10000);
            } else if (error.response.status === 422) {
                notify({
                    group: "bottom",
                    title: "Impossible d'annuler",
                    text: "Ce virement ne peut pas être annulé (déjà traité ou annulé).",
                    type: "error"
                }, 10000);
            } else {
                notify({
                    group: "bottom",
                    title: "Erreur d'annulation",
                    text: error.response.data.message || "Une erreur est survenue lors de l'annulation.",
                    type: "error"
                }, 10000);
            }
        } else {
            notify({
                group: "bottom",
                title: "Erreur d'annulation",
                text: "Une erreur est survenue lors de l'annulation du virement.",
                type: "error"
            }, 10000);
        }
        
        console.warn('ERROR: ' + error);
        throw error;
    }
}
